import React from "react";
import { Logo } from "./Brand";
import { useI18n } from "../i18n/I18nProvider";

const Footer = () => {
    const { t } = useI18n();
    return (
        <footer data-testid="site-footer" className="bg-[#0F1216] text-white mt-12">
            <div className="max-w-[1320px] mx-auto px-5 md:px-8 py-10 flex flex-col md:flex-row items-center justify-between gap-6">
                <Logo light />
                <div className="text-sm text-white/60">
                    {t("footer_made_in")}
                </div>
                <div className="text-xs text-white/50">
                    © {new Date().getFullYear()} mybazaarcart.com
                </div>
            </div>
        </footer>
    );
};

export default Footer;
